import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "outer bg" }
const _hoisted_2 = { class: "inner behind" }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "inner front" }
const _hoisted_7 = ["src"]

import { computed } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'CRommeHeader',
  props: {
    language: {}
  },
  setup(__props: any) {

const props = __props
const logosAvailableForLocales = ['de', 'nl', 'fr']

const logoLocale = computed(() => {
  return logosAvailableForLocales.indexOf(props.language) !== -1 ? `_${props.language}` : ''
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: require(`@/assets/romme/romme_logo_glow.png`),
        class: "logo-bg"
      }, null, 8, _hoisted_3),
      _createElementVNode("img", {
        src: require(`@/assets/romme/romme_swoosh.png`),
        class: "swoosh"
      }, null, 8, _hoisted_4),
      _createElementVNode("img", {
        src: require('@/assets/romme/romme_cards_behind.png'),
        class: "cards",
        alt: "Shiny Romme cards"
      }, null, 8, _hoisted_5)
    ]),
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "shadow" }, null, -1)),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("img", {
        src: require(`@/assets/romme/romme_logo${logoLocale.value}.png`),
        class: "logo"
      }, null, 8, _hoisted_7)
    ])
  ]))
}
}

})